// #region imports

// --- Angular
import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';

// HS Code
import { Constants, LanguageModel, SelectListItem } from '../../models';
import { Utils } from '../../shared';

// #endregion

@Component({
  selector: 'hs-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguagePickerComponent implements OnChanges {
  private readonly _DECIMAL_RADIX: number = 10;

  @Input() languages: LanguageModel[] | null = null;
  @Input() selectedLanguage: LanguageModel | null = null;
  @Input() smallList = false;

  @Output() languageChanged = new EventEmitter<LanguageModel>();

  values: SelectListItem[] | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['languages'] && changes['languages'].currentValue) {
      this.sortIsoCodes();
    }
  }

  onSelectedLanguageChanged(selectedId: string): void {
    const languageId = parseInt(selectedId, this._DECIMAL_RADIX);
    const selectedLanguage : LanguageModel | undefined = this.languages?.find(l => {
      return l.id === languageId;
    });
    if (selectedLanguage && selectedLanguage.id !== this.selectedLanguage?.id) {
      if (!Utils.isNull(selectedLanguage) && !Utils.isUndefined(selectedLanguage)) {
        this.languageChanged.emit(selectedLanguage);
      }
    }
  }

  sortIsoCodes(){
    if(this.languages){

      let sortedLanguages = new Array<LanguageModel>();
      this.languages.forEach(val => sortedLanguages.push(Object.assign({}, val)));

      const enLanguages = sortedLanguages.filter(item => item.isoTwoLetterName === Constants.DEFAULT_LANGUAGE.isoTwoLetterCode);
      sortedLanguages = sortedLanguages.filter(item => item.isoTwoLetterName !== Constants.DEFAULT_LANGUAGE.isoTwoLetterCode);

      sortedLanguages.sort(function(a, b){
        const aLanguage = a.cultureCode ? a.isoThreeLetterName.toLowerCase() + ' ' +  a.cultureCode.toLowerCase()  : a.isoThreeLetterName.toLowerCase();
        const bLanguage = b.cultureCode ? b.isoThreeLetterName.toLowerCase() + ' ' +  b.cultureCode.toLowerCase()  : b.isoThreeLetterName.toLowerCase();

        if(aLanguage < bLanguage) { return -1; }
        if(aLanguage > bLanguage) { return 1; }
        return 0;
      })

      for(var i = 0; i < enLanguages.length ; i++){
        sortedLanguages.splice(i, 0, enLanguages[i]);
      }

      this.values = sortedLanguages.map(l => {
        const isSelected = l.id === (this.selectedLanguage && this.selectedLanguage.id);
        const languageLabel = l.cultureCode ? l.isoThreeLetterName + ' (' +  l.cultureCode + ')' : l.isoThreeLetterName;

        return {
          isSelected,
          isDisabled: false,
          group: null,
          text: languageLabel,
          value: l.id.toString(),
        } as SelectListItem;
      });
    }
  }

}
